import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  infoBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 14,
    marginBottom: theme.spacing(2)
  },
  infoBoxColumn: {
    flex: '1 1 auto',
    padding: '20px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,

    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  infoBoxContent: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '22px',
    color: theme.palette.secondary.dark
  }
}))
